import dynamic from "next/dynamic";
import handleServerSideProps from "components/templates/handleServerSideProps";
import { getTemplate } from "library/helpers/configs";
import CheckoutScript from "../../components/CheckoutScript";
import {getCustomCreatorConfig} from "../../library/helpers/customConfigs/creatorConfig";
import { useMemo } from "react";
import { enableNewCheckoutForFeature } from "constants/constants";
import enableNewCheckoutForChannel from "helpers/enableNewCheckoutForChannel";

const DefaultTemplate = dynamic(() =>
  import("../../components/templates/template-default-channel")
);

const Channel = (props) => {
  const {customTemplateConfig, channelDetails} = props;

  let Template = customTemplateConfig
    ? getTemplate(customTemplateConfig.template)
    : null;

  Template = Template || DefaultTemplate;


  const customCreatorConfig = getCustomCreatorConfig(channelDetails.creator.uid) || {};
  const customConfig = {
    ...customCreatorConfig,
    ...customTemplateConfig
  };

  const enableNewCheckout = enableNewCheckoutForChannel(channelDetails);

  return (
    <>
      <CheckoutScript
        isCustomDomain={customTemplateConfig?.settings?.customDomain}
        enableNewCheckout={enableNewCheckout}
      />
      <Template
        {...props}
        customTemplateConfig={customConfig}
      />
    </>
  );
};

export default Channel;

export const getServerSideProps = async (...args) => {
  try {
    const res = await handleServerSideProps(...args);

    return res;
  } catch (err) {
    console.log("Error...", err);
  }
};
